var staticEscapeMap = require('../static/staticEscapeMap')

var helperFormatEscaper = require('./helperFormatEscaper')

/**
  * 转义HTML字符串，替换&, <, >, ", ', `字符
  *
  * @param {String} str 字符串
  * @return {String}
  */
var escape = helperFormatEscaper(staticEscapeMap)

module.exports = escape



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/string/escape.js
// module id = 1936
// module chunks = 106